<template>
  <ContentSection>
    <ContentTip>
      <strong>Het verhaal groeit!</strong> 
      <p>
        Energieke Verhalen is begonnen met <Link :to="{name: 'list-projecten'}" label="verhalen over projecten" inline />, verbonden aan <Link :to="{name: 'list-themas'}" label="themas" inline />. 
        We werken nu ook aan verhalen over o.a. gemeenten, wijken en betrokken partijen!
      </p>
    </ContentTip>
  </ContentSection>
</template>

<script>

import ContentSection from '@/components/section/ContentSection';
import ContentTip from '@/components/content/Tip';
import Link from '@/components/Link';

export default {
  name: 'GroeiTip',
  components: {
    ContentSection,
    ContentTip,
    Link
  }
}
</script>